import { AxiosInstance } from 'axios';
import { getExportConfig, handleFileExport } from '../../../../../../helpers/fileExport';
import { TRANSACTION_LIST_REPORT_ENDPOINT } from '../endpoint';
import { TransactionsListReportRequestModel } from '../models/TransactionsListReportRequestModel';

export const exportPDF =
  (axios: AxiosInstance) =>
  async (params?: TransactionsListReportRequestModel): Promise<void> => {
    return await axios
      .get(`${TRANSACTION_LIST_REPORT_ENDPOINT}`, {
        params: { ...params },
        ...getExportConfig(params),
      })
      .then(response => {
        handleFileExport(response, {
          file_type: params?.file_type,
          filename: 'transactions-list-report',
        });
      });
  };
